export const first = <T>(arr: readonly T[]) => arr[0]
